import React , { createContext} from 'react'



export const UserContext = createContext('something');
export const UserDetailsContext = createContext('user details')
